import React from 'react';
import PropTypes from 'prop-types';
import CodeMirror from '@uiw/react-codemirror';
import { json } from '@codemirror/lang-json';
import { javascript } from '@codemirror/lang-javascript';
import { markdown } from '@codemirror/lang-markdown';
import { python } from '@codemirror/lang-python';
import { yaml } from '@codemirror/lang-yaml';
import { html } from '@codemirror/lang-html';

import isEmpty from 'lodash/isEmpty';

import SmallLoader from '@shared/components/SmallLoader';
import EmptyPreview from '@experiment-management-shared/components/AssetsPreview/EmptyPreview';
import useAssetById from '@experiment-management-shared/api/useAssetById';

const modeToExtension = {
  json: json(),
  javascript: javascript(),
  markdown: markdown(),
  python: python(),
  yaml: yaml(),
  html: html()
};

const SourceCodePreview = ({
  artifactVersionId,
  assetId,
  experimentKey,
  mode
}) => {
  const { data: asset, isLoading } = useAssetById({
    experimentKey,
    assetId,
    artifactVersionId,
    asText: true
  });

  if (isLoading) {
    return <SmallLoader primaryMessage="Loading..." />;
  }

  if (isEmpty(asset)) {
    return <EmptyPreview message="No preview available." />;
  }

  return (
    <CodeMirror
      value={asset}
      readOnly
      theme="light"
      extensions={[modeToExtension[mode]].filter(Boolean)}
      basicSetup={{
        lineNumbers: true,
        highlightActiveLine: false,
        foldGutter: true
      }}
    />
  );
};

SourceCodePreview.defaultProps = {
  artifactVersionId: undefined
};

SourceCodePreview.propTypes = {
  artifactVersionId: PropTypes.string,
  assetId: PropTypes.string.isRequired,
  experimentKey: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired
};

export default SourceCodePreview;
